// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3ceeV","calendarButtons":"ClockData_calendarButtons__2s0Gd"};